export default {
  Detail: {
    LocalBudgetItemName: 'Khoản chi xã',
    Description: 'Diễn giải',
    ActiveCheckbox: 'Theo dõi',
  },
};
